import { render } from "./Error.vue?vue&type=template&id=39b9aa9e&scoped=true"
import script from "./Error.vue?vue&type=script&lang=js"
export * from "./Error.vue?vue&type=script&lang=js"

import "./Error.vue?vue&type=style&index=0&id=39b9aa9e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-39b9aa9e"

export default script